import { UtilityLibrary, LoggerUtility } from '../components/ComponentsLibrary';

/**
 * Generates mock scrape response data based on case number patterns
 * @param {string} caseNumber - The case number to generate mock data for
 * @returns {Object} Mock scrape response object
 */

// 619275268A - Response for METSS users who are restricted from seeing Confidential cases.
// 619275268Z - Response for METSS users who permitted to see Confidential cases.
// 619275284A - Response for METSS users who are restricted from seeing Confidential cases.
// 619888888A - Made up NonConfidential case with un-mapped FVI value
// 619275217A - NonConfidential with FVI
// 619275209A - NonConfidential
// 619275314A - NonConfidential
// 619275233A - NonConfidential

const getMockResponseForCaseNumber = (caseNumber) => {
    console.log(`🔍 MockResponseUtility: Generating mock response for case number: ${caseNumber}`);
    

    // UPDATED: Make case number comparison case insensitive
    const matchingCase = mockCases.find(mockCase => 
        mockCase.CaseNumber.toLowerCase() === caseNumber.toLowerCase()
    );

    return { ...matchingCase }; // Return a copy to avoid mutations

};

const getMockResponseForNarrativePush = (caseNumber) => {
    
    // Base mock response template matching the expected scrape response structure
    const baseMockResponse = {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "",
        CPSSN: "",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: caseNumber,
        CaseStatus: "",
        CaseType: "",
        CaseWorker: "",
        CaseworkerUserName: "",
        ConfidentialCase: "",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "",
        ErrorCode: "",
        FVIAndConfidentialCase: "",
        FamilyViolence: "",
        HttpStatusCode: "",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "",
        NCPSSN: "",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: ""
    };
    return { ...baseMockResponse };
}

const mockCases = [
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "FINWAY, DOROTHY E.      ",
        CPSSN: "123657410",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275209A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "B5P",
        CaseworkerUserName: "",
        ConfidentialCase: "_",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "      ",
        FamilyViolence: "_",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "CONWAY, ADAM B.",
        NCPSSN: "321459876",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    },
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "ISBELL, JOHN H.     ",
        CPSSN: "314587951",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275314A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "G4A",
        CaseworkerUserName: "",
        ConfidentialCase: "_",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "      ",
        FamilyViolence: "_",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "ISBELL, JEANETTE H.",
        NCPSSN: "321459876",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    },
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "UNDERWOOD, WINONA V.    ",
        CPSSN: "999999999",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275233A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "L79",
        CaseworkerUserName: "",
        ConfidentialCase: "_",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "      ",
        FamilyViolence: "_",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "UNDERWOOD. WILLIAM V. ",
        NCPSSN: "999999999",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    },
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "SANDRA T.",
        CPInfo: "",
        CPLastName: "UPTON",
        CPName: "UPTON, SANDRA T.        ",
        CPSSN: "",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275268A",
        CaseStatus: "",
        CaseType: "",
        CaseWorker: "",
        CaseworkerUserName: "",
        ConfidentialCase: "",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "",
        ErrorCode: "",
        FVIAndConfidentialCase: "DATA MARKED CONFIDENTIAL FOR AP AND CP",
        FamilyViolence: "",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "Mainframe navigation was ended early.",
        NCPFirstName: "SERGEI R.",
        NCPInfo: "",
        NCPLastName: "QUELZAL",
        NCPName: "QUELZAL, SERGEI R.      ",
        NCPSSN: "",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "The case has been marked confidential. Please see your supervisor.",
        iAPECSHttpStatusCode: "200"
    },
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "ONE, NO H.     ",
        CPSSN: "314587951",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619888888A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "G4A",
        CaseworkerUserName: "",
        ConfidentialCase: "_",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "      ",
        FamilyViolence: "Z",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "PERSON, SOMEONE H.",
        NCPSSN: "321459876",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    },
    {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "OWENS, MORIS N.      ",
        CPSSN: "123657410",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275284A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "B5P",
        CaseworkerUserName: "",
        ConfidentialCase: "",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "DATA MARKED CONFIDENTIAL FOR THIS CP",
        FamilyViolence: "",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "KINSINGTON, MADELYN L.",
        NCPSSN: "321459876",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "The case has been marked confidential. Please see your supervisor.",
        iAPECSHttpStatusCode: "200"
    },
        {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "OWENS, MORIS N.      ",
        CPSSN: "123657410",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275217A",
        CaseStatus: "1",
        CaseType: "40",
        CaseWorker: "B5P",
        CaseworkerUserName: "",
        ConfidentialCase: "_",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "01",
        ErrorCode: "",
        FVIAndConfidentialCase: "WARNING: FAMILY VIOLENCE CASE INVOLVED",
        FamilyViolence: "Y",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "KINSINGTON, MADELYN L.",
        NCPSSN: "321459876",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    },
        {
        AlertMessage: "",
        AlertStatusMessage: "",
        CPFirstName: "",
        CPInfo: "",
        CPLastName: "",
        CPName: "UPTON, SANDRA T.        ",
        CPSSN: "000000000",
        CPSSN_Formated: "",
        CPid: "",
        CaseClosedMessage: "",
        CaseFound: "", 
        CaseNumber: "619275268Z",
        CaseStatus: "1",
        CaseType: "",
        CaseWorker: "",
        CaseworkerUserName: "",
        ConfidentialCase: "Y",
        CountyID: "",
        DistributionDate: "",
        DistrictID: "",
        ErrorCode: "",
        FVIAndConfidentialCase: "",
        FamilyViolence: "N",
        HttpStatusCode: "200",
        Last4SSN: "",
        Message: "Mainframe navigation was ended early.",
        NCPFirstName: "",
        NCPInfo: "",
        NCPLastName: "",
        NCPName: "QUELZAL, SERGEI R.      ",
        NCPSSN: "",
        NCPSSN_Formated: "",
        NCPid: "",
        OfficeNumber: "",
        RestrictedStatusMessage: "",
        iAPECSHttpStatusCode: "200"
    }
];


const MockResponseUtility = {
    getMockResponseForCaseNumber,
    getMockResponseForNarrativePush
};


export default MockResponseUtility;